import {
  CONFIRMED_ADD_INWARD_STOCK,
  CONFIRMED_DELETE_INWARD_STOCK,
  CONFIRMED_GET_INWARD_STOCK_DETAILS,
  CONFIRMED_GET_INWARD_STOCK_LIST,
  INWARD_STOCK_LOADING,
  INWARD_STOCK_ERROR,
 
} from "../types/inwardStockTypes";

import {
  addInwardStockAPI,
  formatInwardStock,
  getInwardStockListAPI,
  deleteInwardStock,
 getInwardStockDetailsAPI,
 formatInwardStockDetails
} from "../../services/inwardStockService";


import { handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService";

// Get inward stock list
export function getInwardStockListAction(
  pagination = true,
  pageid = 0,
  search_by = "",
  search_keyword = "",
  sort_by = "",
  sort_order = ""
) {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: INWARD_STOCK_LOADING });

      const response = await  getInwardStockListAPI(
        pagination,
        pageid,
        search_by,
        search_keyword,
        sort_by,
        sort_order
      );

      if (response && response.status === 200 && response.data) {
        if (response.data.status === "success" && response.data.data) {
          const inwardStocks = formatInwardStock(response.data.data);
          dispatch({
            type: CONFIRMED_GET_INWARD_STOCK_LIST,
            payload: {
              inwardStocks: inwardStocks,
              num_rows: response.data.num_rows || 0,
            },
          });
        } else {
          dispatch({
            type: INWARD_STOCK_ERROR,
            payload: "Failed to get inward stock: Server error",
          });
          showErrorAlert("Failed to get inward stock: Server error");
        }
      } else {
        dispatch({
          type: INWARD_STOCK_ERROR,
          payload: "Failed to get inward stock: Network error",
        });
        showErrorAlert("Failed to get inward stock: Network error");
      }
    } catch (error) {
      console.error("API Error:", error.response || error);
      dispatch({
        type: INWARD_STOCK_ERROR,
        payload: error.message,
      });
      showErrorAlert("Failed to get inward stock");
    }
  };
}

// Add inward stock
export function addInwardStockAction(payload) {
  return async (dispatch) => {
    try {
      dispatch({ type: INWARD_STOCK_LOADING });

      const response = await addInwardStockAPI(payload);

      if (response?.status === 200 && response.data) {
        if (response.data.status === "success") {
          dispatch({
            type: CONFIRMED_ADD_INWARD_STOCK,
            payload: response.data,  // ✅ Use response.data
          });
          handleSuccess(response.data.message || "Inward stock added successfully!");
          return { success: true, data: response.data };
        } else {
          dispatch({
            type: INWARD_STOCK_ERROR,
            payload: response.data.message || "Failed to add inward stock",
          });
          showErrorAlert(response.data.message || "Failed to add inward stock");
          return { success: false, error: response.data.message };
        }
      } else {
        dispatch({
          type: INWARD_STOCK_ERROR,
          payload: "Failed to add inward stock",
        });
        showErrorAlert("Failed to add inward stock");
        return { success: false, error: "Failed to add inward stock" };
      }
    } catch (error) {
      console.error("Error adding inward stock:", error);
      const errorMessage = error.response?.data?.message || error.message || "Failed to add inward stock";
      dispatch({
        type: INWARD_STOCK_ERROR,
        payload: errorMessage,
      });
      showErrorAlert(errorMessage);
      return { success: false, error: errorMessage };
    }
  };
}

// Delete inward stock
// Delete inward stock
export function deleteInwardStockAction({ inward_id, reason }) {
  return async (dispatch) => {
    try {
      dispatch({ type: INWARD_STOCK_LOADING });

      // Pass both inward_id and reason to the API
      const response = await deleteInwardStock({ inward_id, reason });

      if (response?.status === 200 && response.data) {
        if (response.data.status === "success") {
          dispatch({
            type: CONFIRMED_DELETE_INWARD_STOCK,
            payload: { inward_id },
          });
          handleSuccess(response.data.message || "Inward stock deleted successfully!");
          
          // Refresh the inward stock list after successful deletion
          dispatch(getInwardStockListAction());
          
          return { success: true };
        } else {
          dispatch({
            type: INWARD_STOCK_ERROR,
            payload: response.data.message || "Failed to delete inward stock",
          });
          showErrorAlert(response.data.message || "Failed to delete inward stock");
          return { success: false, error: response.data.message };
        }
      } else {
        dispatch({
          type: INWARD_STOCK_ERROR,
          payload: "Failed to delete inward stock: Network error",
        });
        showErrorAlert("Failed to delete inward stock: Network error");
        return { success: false, error: "Network error" };
      }
    } catch (error) {
      console.error("Error deleting inward stock:", error);
      const errorMessage = error.response?.data?.message || error.message || "Failed to delete inward stock";
      dispatch({
        type: INWARD_STOCK_ERROR,
        payload: errorMessage,
      });
      showErrorAlert(errorMessage);
      return { success: false, error: errorMessage };
    }
  };
}
// Update inward stock
export function getInwardStockDetailsAction(inward_id) {
  return async (dispatch) => {
    try {
      dispatch({ type: INWARD_STOCK_LOADING });

      const response = await getInwardStockDetailsAPI(inward_id);

      console.log("getInwardStockDetailsAPI response:", response);

      if (response && response.status === 200 && response.data) {
        if (response.data.status === "success") {
          // The data is directly the array of inward items
          const inwardDetails = formatInwardStockDetails(response.data.data);
          dispatch({
            type: CONFIRMED_GET_INWARD_STOCK_DETAILS,
            payload: inwardDetails,
          });
          return { success: true, data: inwardDetails };
        } else {
          dispatch({
            type: INWARD_STOCK_ERROR,
            payload: response.data.message || "Failed to get inward stock details",
          });
          showErrorAlert(response.data.message || "Failed to get inward stock details");
          return { success: false, error: response.data.message };
        }
      } else {
        dispatch({
          type: INWARD_STOCK_ERROR,
          payload: "Failed to get inward stock details: Network error",
        });
        showErrorAlert("Failed to get inward stock details: Network error");
        return { success: false, error: "Network error" };
      }
    } catch (error) {
      console.error("API Error:", error.response || error);
      const errorMessage = error.response?.data?.message || error.message || "Failed to get inward stock details";
      dispatch({
        type: INWARD_STOCK_ERROR,
        payload: errorMessage,
      });
      showErrorAlert(errorMessage);
      return { success: false, error: errorMessage };
    }
  };
}
